import styled from '@emotion/styled';

const StyledTime = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  text-align: center;
`;

const TopContainer = styled.div`
  display: flex;
  align-items: center;
`;
const BottomContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 0 4px;
`;
const Container = styled.div`
  border-radius: 8px;
  border: 1px solid #fff;
  background: rgba(199, 122, 196, 0.12);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08) inset,
    0px 8px 32px 0px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(12px);
  position: absolute;
  padding: 6px 8px;
  bottom: 100px;
  right: 100px;
  color: #c77ac4;
  min-width: 320px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  z-index: 1201;
`;

const ButtonContainer = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 4px;
  :hover {
    background-color: rgba(199, 122, 196, 0.16);
  }
  :active {
    background-color: rgba(199, 122, 196, 0.24);
  }
`;

const StyledTitle = styled.div`
  flex-grow: 1;
  margin-left: 8px;
  margin-right: 24px;
`;

export {
  StyledTime,
  TopContainer,
  BottomContainer,
  Container,
  ButtonContainer,
  StyledTitle,
};
